import CustomCSSCard from "@/pages/(app)/customer-portal/components/custom-css/custom-css-card";
import SettingsFormContainer, {
  SettingsFormHeader,
  SettingsFormSectionHeader,
} from "@babackapp/react-hook-forms-components/form-page";
import useTranslation from "@babackapp/translations/use-translation";
import { CustomMessagesList } from "./components/custom-messages-settings/custom-message-settings-list";
import CustomerPortalBasicsCard from "./components/customer-portal-basics/customer-portal-basics-card";
import CustomerPortalNotificationsCard from "./components/customer-portal-notifications/customer-portal-notifications-card";
import DiscountFormCard from "./components/discount-settings/discount-form-card";
import RefundFormCard from "./components/refund-settings/portal-refund-card";
import PortalExchange from "./components/portal-exchange-form/portal-exchange-card";
import ReturnReasonList from "./components/return-reason-settings/return-reason-list";
import ShopCustomizationCard from "./components/shop-customization/shop-customization-card";

export default function CustomerPortalPage() {
  const t = useTranslation();

  return (
    <>
      <SettingsFormContainer
        navigation={[
          {
            title: t("settings.customerPortal.sections.basics.title"),
            id: "basic-informations",
          },
          {
            title: t("settings.customerPortal.sections.notifications.title"),
            id: "notifications",
          },
          {
            title: t("settings.customerPortal.sections.customization.title"),
            id: "customization",
          },
          {
            title: t("settings.config.merchandCss"),
            id: "custom-css",
          },
          {
            title: t("settings.customerPortal.sections.exchanges.title"),
            id: "exchanges",
          },
          {
            title: t("settings.customerPortal.sections.discounts.title"),
            id: "discounts",
          },
          {
            title: t("settings.customerPortal.sections.refunds.title"),
            id: "refunds",
          },
          {
            title: t("settings.customerPortal.sections.customMessages.title"),
            id: "custom-messages",
          },
          {
            title: t("settings.customerPortal.sections.returnReasons.title"),
            id: "return-reasons",
          },
        ]}
      >
        <SettingsFormHeader
          title={t("settings.customerPortal.title")}
          description={t("settings.customerPortal.description")}
        />

        <SettingsFormSectionHeader
          title={t("settings.customerPortal.sections.basics.title")}
          id={"basic-informations"}
        />
        <CustomerPortalBasicsCard />

        <SettingsFormSectionHeader
          title={t("settings.customerPortal.sections.notifications.title")}
          id={"notifications"}
        />
        <CustomerPortalNotificationsCard />

        <SettingsFormSectionHeader
          title={t("settings.customerPortal.sections.customization.title")}
          id={"customization"}
        />
        <ShopCustomizationCard />

        <SettingsFormSectionHeader
          title={t("settings.config.merchandCss")}
          id={"custom-css"}
        />
        <CustomCSSCard />

        <SettingsFormSectionHeader
          title={t("settings.customerPortal.sections.exchanges.title")}
          id={"exchanges"}
        />
        <PortalExchange />

        <SettingsFormSectionHeader
          title={t("settings.customerPortal.sections.discounts.title")}
          id={"discounts"}
        />
        <DiscountFormCard />
        <SettingsFormSectionHeader
          title={t("settings.customerPortal.sections.refunds.title")}
          id={"refunds"}
        />
        <RefundFormCard />

        <SettingsFormSectionHeader
          title={t("settings.customerPortal.sections.customMessages.title")}
          id={"custom-messages"}
        />
        <CustomMessagesList />

        <SettingsFormSectionHeader
          title={t("settings.customerPortal.sections.returnReasons.title")}
          id={"return-reasons"}
        />
        <ReturnReasonList />
      </SettingsFormContainer>
    </>
  );
}
